<template>
  <el-dialog
    :title="Baslik"
    :visible="ModalOlayi"
    center
    width="70%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-form :model="data" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
      <input v-model="data.id" type="hidden"></input>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Ad Soyad" prop="AdSoyad">
            <el-input v-model="data.AdSoyad"></el-input>
          </el-form-item>
          <small v-if="data.id">Kullanıcı özel bilgilerini kullanıcı düzenleyebilir</small>
        </el-col>
        <el-col :span="data.span">
          <el-form-item label="Telefon" prop="Telefon">
            <el-input v-model="data.Telefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="data.span">
          <el-form-item label="Email" prop="Email">
            <el-input type="email" v-model="data.Email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="data.id && !data.Yetkili">
          <el-form-item class="Tooltip" :label="$t('eYonetim.20.6')" prop="durum">
            <el-tooltip class="item" effect="dark"
                        content="Kullanıcı sistem kullanım durum (Admin hesapları etkilenmez)"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-switch v-model="data.durum"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-alert
        v-if="!data.id"
        title="KVKK Kuralları gereği şifre sistem tarafından üretilip kullanıcıya mail olarak iletilecektir."
        type="info"
        :closable="false"
      >
      </el-alert>
      <hr>
      <h6 class="m-0">
        <span class="mt-2" style="display: inline-block">Program Yetkileri</span>

        <el-form-item class="Tooltip float-right" label="Admin" prop="Yetkili"
                      style="top:-10px;margin-bottom:-20px !important;position: relative">
          <el-tooltip class="item" effect="dark"
                      content="Sistemdeki bütün yetkiler ve sadece hesap sahibinin göreceği bilgileri görür"
                      placement="top">
            <i class="el-icon-info text-primary cursor-pointer"></i>
          </el-tooltip>
          <el-switch v-model="data.Yetkili"></el-switch>
        </el-form-item>
        <el-form-item v-if="!data.Yetkili" class="Tooltip float-right" label="Tahsilat Merkezi" prop="Veznedar"
                      style="top:-10px;margin-bottom:-20px !important;position: relative">
          <el-tooltip class="item" effect="dark"
                      content="Aidatım Veznedar Yetkisi"
                      placement="top">
            <i class="el-icon-info text-primary cursor-pointer"></i>
          </el-tooltip>
          <el-switch v-model="data.Veznedar"></el-switch>
        </el-form-item>
      </h6>
      <div class="clearfix"></div>
      <div v-if="data.Veznedar">
        <hr>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-alert
              title="Aidatım ile tahsilat merkezi ekleyerek tahsilat ağınızı genişletebilirsiniz."
              type="info"
              :closable="false"
            >
            </el-alert>
            <br>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Kasa" prop="Kasa">
              <el-cascader
                collapse-tags
                placeholder="Kasa Seçiniz"
                :props="{ multiple: false}"
                :options="Kasalar"
                v-model="data.TahsilatMerkezi.Kasa_id"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="Tooltip" label="Tahsilat Limit" prop="Limit">
              <el-tooltip class="item" effect="dark"
                          content="Tahsilat merkezinin tahsilat yapacağı tutar limiti."
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="data.TahsilatMerkezi.Limit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Komisyon" prop="Komisyon">
              <el-tooltip class="item" effect="dark"
                          content="Tahsilat merkezinin ödenecek tutar üzerinden alacağı komisyon"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="data.TahsilatMerkezi.Komisyon"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Minimum Tutar" prop="Tutar">
              <el-tooltip class="item" effect="dark"
                          content="Tahsilat merkezinin ödenecek tutar üzerinden alacağı komisyon minimum tutardan küçükse alınacak tutar."
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="data.TahsilatMerkezi.Tutar"></el-input>
            </el-form-item>
          </el-col>


        </el-row>
      </div>
      <div v-if="!data.Yetkili & !data.Veznedar">
        <hr>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Yönetim Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.yonetim" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Vezne Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.vezne" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Muhasebe Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.muhasebe" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Kasa Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.kasa" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Raporlama Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.raporlama" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="İcra Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.icra" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="İletişim Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.iletisim" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="İptal Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.iptal" filterable>
                <el-option
                  v-for="item in IptalYetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Entegrasyon Modülü" prop="Yetki">
              <el-select v-model="data.Yetki.entegrasyon" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item class="Tooltip" label="KVKK" prop="Yetki">
              <el-tooltip class="item" effect="dark" content="TC Kimlik ve Telefon bilgisine tam erişim"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-select v-model="data.Yetki.KVKK" filterable>
                <el-option
                  v-for="item in Yetkilers"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Makbuz İptal" prop="Yetki">
              <el-select v-model="data.Yetki.MakbuzIptal" filterable>
                <el-option
                  v-for="item in Yetkilers"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item class="Tooltip" label="Vezne Tarih" prop="Yetki">
              <el-tooltip class="item" effect="dark" content="Veznede hesaplama tarihi işlemi"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-select v-model="data.Yetki.VezneTarih" filterable>
                <el-option
                  v-for="item in Yetkilers"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item class="Tooltip" label="Not ve Arşiv" prop="Yetki">
              <el-tooltip class="item" effect="dark" content="Not ve Arşiv işlemleri yetkisi"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-select v-model="data.Yetki.NotArsiv" filterable>
                <el-option
                  v-for="item in Yetkiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item class="Tooltip" label="İcra Tahsilat" prop="Yetki">
              <el-tooltip class="item" effect="dark" content="İcralık dosyalarda dosyayı çözmeden tahsilat alma yetkisi"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-select v-model="data.Yetki.IcraTahsilat" filterable>
                <el-option
                  v-for="item in Yetkilers"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="24">
            <el-alert
              title="Site / Bina seçimi yapılmazsa tüm site ve binalara yetkilerine göre işlem yapabilir"
              type="info"
              :closable="false"
            >
            </el-alert>
            <el-form-item label="Bina Yetkisi" prop="Yetki">
              <el-select v-model="data.Binalar" placeholder="Kısıtlama için seçim yapınız" filterable multiple>
                <el-option-group
                  label="BİNALAR">
                  <el-option
                    v-for="item in BinaListe"
                    v-if="!item.Alt"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  v-for="item in BinaListe"
                  v-if="item.Alt"
                  :key="item.id"
                  :label="item.Adi">
                  <el-option
                    v-for="ab in item.Alt"
                    :key="ab.id"
                    :label="ab.Adi"
                    :value="ab.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  label="SİTELER">
                  <el-option
                    v-for="item in BinaListe"
                    v-if="item.Alt"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>

          </el-col>
        </el-row>
      </div>
    </el-form>
    <hr v-if="data.id">
    <el-alert
      v-if="data.id"
      title="Güncelleme durumunda Kullanıcının aktif oturumu kapatılacaktır."
      type="warning"
      :closable="false"
    >
    </el-alert>

    <div slot="footer" class="dialog-footer">
      <el-button v-if="!lo" type="primary" size="medium" @click="Submit()" icon="el-icon-check">
        {{$t('eGenel.0')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      ModalOlayi: Boolean,
      Baslik: String,
      data: {
        type: Object,
        require: true
      },
    },
    data() {
      return {
        lo: false,
        Yetkiler: [
          {value: '0', label: 'Yetki Yok'},
          {value: '1', label: 'Sadece Görebilir'},
          {value: '2', label: 'Tüm İşlemleri Gerçekleştirebilir'}
        ],
        IptalYetkiler: [
          {value: '0', label: 'Yetki Yok'},
          {value: '1', label: 'Düzenleyebilir'},
          {value: '2', label: 'Tüm İşlemleri Gerçekleştirebilir'}
        ],
        Yetkilers: [
          {value: '0', label: 'İzin Yok'},
          {value: '1', label: 'İzin Var'}
        ],
        FormHata: {
          AdSoyad: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Email: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        BinaListe: [],
        Kasalar: [],
      }
    },
    methods: {
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            if (this.data.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.data,
                path: 'kullanici/' + this.data.id
              })
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            } else {
              // EKLE
              this.$store.dispatch("Post", {...this.data, path: 'kullanici'})
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });

      }
    },
    created() {
      if (!this.data.TahsilatMerkezi) {
        this.data.TahsilatMerkezi = {
          Kasa_id: null,
          Limit: null,
          Komisyon: null,
          Tutar: null
        }
      }
      this.$store.dispatch("Get", {path: 'spesiyal/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.BinaListe = response.Liste
          } else {
            this.$message.error(response.Mesaj);
          }
        });

      this.$store.dispatch("Get", {path: 'muhasebe/kasa'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kasalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
          }
        });

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pack/Kulanici/FormModal.vue